import * as React from "react";
const SvgRowMax = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 3.502v.503h13.747V3H1v.502Zm1.562 8.125v.5h10.624v-.999H2.562v.5Z", fill: "currentColor" })));
export default SvgRowMax;
